import React from 'react';
import { useMount } from 'react-use';
import ym from 'react-yandex-metrika';
import { useHistory } from 'react-router';

import { TeacherReserveWidget } from '@edu-frontend/modules/src/widgets/teacherReserveCarousels';
import { ThemeProvider } from '@edu-frontend/modules/src/shared/lib/ThemeProvider';
import { hrLight } from '@edu-frontend/modules/src/components/ui/Theme';
import { useStaticUrls } from 'platform-components';

import { WidgetWrapper } from '../../widgets.widget-wrapper/widget-wrapper';
import { useTeacherReserveParams } from '../lib/use-teacher-reserve-params';

export const TeacherReserveActive = () => {
    const history = useHistory();
    const params = useTeacherReserveParams();
    const staticUrls = useStaticUrls();

    useMount(() => {
        ym('reachGoal', 'teacher_talent_pool_view');
    });

    if (params.error) {
        return null;
    }

    const navigateToTeacherReservePage = () => {
        history.push(staticUrls.labTeacherReserve);
    };

    return (
        <WidgetWrapper background="#F4F5F6" fullWidth={true}>
            <ThemeProvider isRoot={false} theme={hrLight}>
                <TeacherReserveWidget navigateToTeacherReservePage={navigateToTeacherReservePage} {...params} />
            </ThemeProvider>
        </WidgetWrapper>
    );
};
